export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => {
        if (!e) return null;
        const loc = Array.isArray(e.loc) ? e.loc.filter((l) => l !== "body").join(".") : "";
        return typeof e.msg === "string" ? (loc ? `${loc}: ${e.msg}` : e.msg) : JSON.stringify(e);
      })
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatApiError(err, fallback = "Request failed. Please try again.") {
  if (!err) return fallback;
  if (err.code === "ECONNABORTED") return "The request timed out. Please try again.";
  if (!err.response && err.message === "Network Error") return "Can't reach the server. Check your connection.";
  const detail = err?.response?.data?.detail;
  const message = err?.response?.data?.message;
  if (detail) return formatApiErrorDetail(detail);
  if (message) return String(message);
  if (err.message) return err.message;
  return fallback;
}
